"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.function.name");

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

require("core-js/modules/es6.number.constructor");

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _auth = require("@/utils/auth");

var _vuex = require("vuex");

var _ossUpload = _interopRequireDefault(require("@/views/cms/common/ossUpload"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default2 = {
  name: 'ContractForm',
  components: {
    OssUpload: _ossUpload.default
  },
  props: {
    custId: {
      type: [String, Number],
      required: true
    },
    contract: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      contractForm: {
        id: '',
        contractNo: '',
        type: '',
        customerName: '',
        customerPhone: '',
        orderNo: '',
        contractAmount: 0,
        budgetAmount: 0,
        address: '',
        images: [],
        attachments: [],
        orderType: '',
        contractTime: '',
        amountReceived: 0,
        approvalInfo: '',
        approveDatetime: '',
        approveUser: '',
        contractdetailImgs: '',
        deliveryAmount: 0,
        remark: '',
        approveRemark: '',
        guideUserName: '',
        guideNickName: '',
        contractStatusEnumeration: '',
        positioning: '',
        designerUserName: '',
        designerNickName: '',
        contactPersonUserName: '',
        contactPersonNickName: '',
        orderClerkUserName: '',
        orderClerkNickName: '',
        measureTime: '',
        recoveryTime: '',
        confirmPlanTime: '',
        unmeasured: '',
        signingTime: '',
        signatureDate: '',
        scheduledDeliveryDate: '',
        agreedConstructionPeriod: '',
        custId: ''
      },
      contractRules: {
        contractNo: [{
          required: true,
          message: '请输入合同号',
          trigger: 'blur'
        }],
        orderType: [{
          required: true,
          message: '请选择订单类型',
          trigger: 'blur'
        }],
        type: [{
          required: true,
          message: '请选择合同类型',
          trigger: 'change'
        }],
        customerName: [{
          required: true,
          message: '请输入客户姓名',
          trigger: 'blur'
        }],
        customerPhone: [{
          required: true,
          message: '请输入客户电话',
          trigger: 'blur'
        }],
        contractAmount: [{
          required: true,
          message: '请输入合同金额',
          trigger: 'blur'
        }],
        contractTime: [{
          required: true,
          message: '请选择合同签订时间',
          trigger: 'blur'
        }]
      },
      headers: {
        'Authorization': (0, _auth.getToken)()
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['baseApi', 'filesUploadApi'])), {}, {
    dict: function dict() {
      return this.$store.state.dict;
    },
    imgPreviewPrefix: function imgPreviewPrefix() {
      return this.$store.getters.imgPreviewPrefix;
    }
  }),
  mounted: function mounted() {
    // 组件挂载时初始化数据
    this.init();
  },
  watch: {
    // 监听contract变化，重新加载数据
    contract: {
      handler: function handler(newVal) {
        if (newVal) {
          this.init();
        }
      },
      deep: true
    },
    // 监听custId变化，重新设置custId
    custId: {
      handler: function handler(newVal) {
        if (newVal) {
          this.contractForm.custId = newVal;
        }
      },
      immediate: true
    }
  },
  methods: {
    init: function init() {
      var _this = this;

      if (this.contract) {
        // 回显合同图片（使用 imgPreviewPrefix 拼接）
        var images = [];

        if (this.contract.contractImgs) {
          try {
            var parsedImgs = JSON.parse(this.contract.contractImgs);
            images = parsedImgs.map(function (img) {
              return {
                name: img.realName,
                url: "".concat(_this.imgPreviewPrefix).concat(img.realName)
              };
            });
          } catch (e) {
            console.error('解析合同图片数据失败:', e);
          }
        } // 回显合同附件


        this.$nextTick(function () {
          if (_this.contract.file && _this.$refs.ossFileUpload) {
            try {
              var parsedFiles = JSON.parse(_this.contract.file);

              if (Array.isArray(parsedFiles)) {
                var filePreviewPrefix = _this.$store.getters.filePreviewPrefix || '';
                var fileList = parsedFiles.map(function (file) {
                  return {
                    realName: file.realName,
                    url: file.url || filePreviewPrefix + file.realName,
                    name: file.name || file.alias || file.localName || file.realName,
                    alias: file.alias || file.name || file.realName,
                    localName: file.localName || file.name || file.alias || file.realName,
                    size: file.size || 0
                  };
                });

                _this.$refs.ossFileUpload.setFileList(fileList);
              }
            } catch (e) {
              console.error('解析合同附件数据失败:', e);
            }
          }
        });
        this.contractForm = _objectSpread(_objectSpread({}, this.contract), {}, {
          type: this.contract.type || '',
          customerName: this.contract.customerName || '',
          customerPhone: this.contract.customerPhone || '',
          orderNo: this.contract.orderNo || '',
          contractAmount: this.contract.amount || 0,
          budgetAmount: this.contract.budgetAmount || 0,
          address: this.contract.address || '',
          images: images,
          attachments: [],
          orderType: this.contract.orderType || '',
          contractTime: this.contract.contractTime || '',
          amountReceived: this.contract.amountReceived || 0,
          approvalInfo: this.contract.approvalInfo || '',
          approveDatetime: this.contract.approveDatetime || '',
          approveUser: this.contract.approveUser || '',
          contractdetailImgs: this.contract.contractdetailImgs || '',
          deliveryAmount: this.contract.deliveryAmount || 0,
          remark: this.contract.remark || '',
          approveRemark: this.contract.approveRemark || '',
          guideUserName: this.contract.guideUserName || '',
          guideNickName: this.contract.guideNickName || '',
          contractStatusEnumeration: this.contract.contractStatusEnumeration || '',
          positioning: this.contract.positioning || '',
          designerUserName: this.contract.designerUserName || '',
          designerNickName: this.contract.designerNickName || '',
          contactPersonUserName: this.contract.contactPersonUserName || '',
          contactPersonNickName: this.contract.contactPersonNickName || '',
          orderClerkUserName: this.contract.orderClerkUserName || '',
          orderClerkNickName: this.contract.orderClerkNickName || '',
          measureTime: this.contract.measureTime || '',
          recoveryTime: this.contract.recoveryTime || '',
          confirmPlanTime: this.contract.confirmPlanTime || '',
          unmeasured: this.contract.unmeasured || '',
          signingTime: this.contract.signingTime || '',
          signatureDate: this.contract.signatureDate || '',
          scheduledDeliveryDate: this.contract.scheduledDeliveryDate || '',
          agreedConstructionPeriod: this.contract.agreedConstructionPeriod || '',
          custId: this.contract.custId || this.custId
        });
      }
    },
    validate: function validate() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.$refs.contractForm.validate(function (valid) {
          if (valid) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    // 生成合同编号
    getContractNumber: function getContractNumber() {
      var _this3 = this;

      if (this.contractForm.orderType) {
        (0, _cmsWorkOrder.generateContractNo)({
          type: this.contractForm.orderType
        }).then(function (res) {
          _this3.contractForm.contractNo = res;
        }).catch(function (err) {
          console.error('生成合同编号失败:', err);
        });
      }
    },
    // ===== 图片上传（服务端中转） =====
    handleImageUploadSuccess: function handleImageUploadSuccess(response, file, fileList) {
      // 从服务器响应中提取 realName，补上完整预览 URL
      if (file && !file.url && response) {
        var realName = response.realName || response;

        if (typeof realName === 'string') {
          file.url = this.imgPreviewPrefix + realName;
        }
      }

      this.contractForm.images = fileList;
      this.$emit('upload-success', response, 'image');
    },
    handleImageRemove: function handleImageRemove(file, fileList) {
      this.contractForm.images = fileList;
      this.$emit('delete-success', file, 'image');
    },
    // ===== 附件上传（OSS 直传） =====
    // 附件上传成功
    handleFileUploadSuccess: function handleFileUploadSuccess(fileInfo, allFiles) {
      this.contractForm.attachments = allFiles;
      this.$emit('upload-success', fileInfo, 'file');
    },
    // 附件删除成功
    handleFileDeleteSuccess: function handleFileDeleteSuccess(file, remainFiles) {
      this.contractForm.attachments = remainFiles;
      this.$emit('delete-success', file, 'file');
    },
    // 获取文件名
    getFileName: function getFileName(fileUrl) {
      if (!fileUrl) {
        return '';
      }

      var parts = fileUrl.split('/');
      return parts[parts.length - 1];
    },

    /**
     * 获取上传文件的序列化数据（供父组件保存时使用）
     * @returns {{ images: Array, files: Array }}
     */
    getUploadData: function getUploadData() {
      // 图片数据从 el-upload 的 fileList 中提取 response
      var images = [];

      if (this.contractForm.images && this.contractForm.images.length > 0) {
        this.contractForm.images.forEach(function (file) {
          if (file.response) {
            try {
              var obj = typeof file.response === 'string' ? JSON.parse(file.response) : file.response;
              images.push(obj);
            } catch (e) {
              console.error('解析图片上传响应失败:', e);
            }
          }
        });
      } // 附件数据从 ossUpload 组件获取


      var files = this.$refs.ossFileUpload ? this.$refs.ossFileUpload.getUploadedFiles() : [];
      return {
        images: images,
        files: files
      };
    },
    // 重置表单
    resetForm: function resetForm() {
      this.$refs.contractForm.resetFields();
    }
  }
};
exports.default = _default2;